"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _api = require("../../api");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'AddCouponDialog',
  data: function data() {
    return {
      dialogVisible: false,
      packageId: null,
      loading: false,
      confirmLoading: false,
      coupons: [],
      total: 0,
      selectedCoupons: [],
      searchForm: {
        name: '',
        couponType: '',
        status: ''
      },
      pageData: {
        page: 1,
        limit: 10
      },
      couponTypeOptions: [{
        label: '满减券',
        value: 1
      }, {
        label: '折扣券',
        value: 2
      }, {
        label: '其他',
        value: 3
      }],
      statusOptions: [{
        label: '未开始',
        value: 0
      }, {
        label: '已开始',
        value: 1
      }, {
        label: '已关闭',
        value: 2
      }, {
        label: '异常关闭',
        value: 3
      }]
    };
  },
  methods: {
    open: function open(packageId) {
      this.packageId = packageId;
      this.dialogVisible = true;
      this.selectedCoupons = [];
      this.resetSearch();
      this.fetchCoupons();
    },
    handleClose: function handleClose() {
      this.dialogVisible = false;
      this.packageId = null;
      this.resetSearch();
    },
    resetSearch: function resetSearch() {
      this.searchForm = {
        name: '',
        couponType: '',
        status: ''
      };
      this.pageData = {
        page: 1,
        limit: 10
      };
      if (this.dialogVisible) {
        this.fetchCoupons();
      }
    },
    clearSelection: function clearSelection() {
      this.$refs.couponTable.clearSelection();
    },
    fetchCoupons: function fetchCoupons() {
      var _this = this;
      this.loading = true;
      var params = {
        page: this.pageData.page,
        limit: this.pageData.limit,
        name: this.searchForm.name,
        couponType: this.searchForm.couponType,
        status: this.searchForm.status
      };
      (0, _api.couponLists)(params).then(function (res) {
        if (res) {
          _this.coupons = res.list || [];
          _this.total = res.total;
          _this.pageData.page = res.page;
          _this.pageData.limit = res.limit;
        } else {
          _this.coupons = [];
          _this.total = 0;
        }
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.selectedCoupons = val;
    },
    handleSearch: function handleSearch() {
      this.pageData.page = 1;
      this.fetchCoupons();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageData.limit = val;
      this.fetchCoupons();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageData.page = val;
      this.fetchCoupons();
    },
    confirmAdd: function confirmAdd() {
      var _this2 = this;
      if (!this.packageId || this.selectedCoupons.length === 0) {
        return;
      }
      this.confirmLoading = true;

      // Add issueCount field to each selected coupon
      var selectedCouponsWithCount = this.selectedCoupons.map(function (coupon) {
        return {
          couponId: Number(coupon.id),
          quantity: 1 // Default to 1 for each coupon
        };
      });

      // Update the data structure to match the expected format
      var requestData = {
        couponIds: selectedCouponsWithCount.map(function (item) {
          return item.couponId;
        }),
        // Keep the quantities data for the batch update API
        couponQuantities: selectedCouponsWithCount
      };
      (0, _api.addCouponToPackageApi)(this.packageId, requestData).then(function (res) {
        if (res) {
          _this2.$message({
            type: 'success',
            message: "\u5DF2\u6210\u529F\u6DFB\u52A0 ".concat(_this2.selectedCoupons.length, " \u5F20\u4F18\u60E0\u5238\u5230\u5238\u5305"),
            duration: 3000
          });
          _this2.confirmLoading = false;
          _this2.handleClose();
          // 通知上级组件刷新数据
          _this2.$emit('refresh');
          // 使用事件总线直接刷新券包详情页面
          _this2.$bus.$emit('refreshPackageDetail');
        } else {
          _this2.$message.error(res && res.message ? res.message : '添加失败');
          _this2.confirmLoading = false;
        }
      }).catch(function (error) {
        console.error('Add coupons error:', error);
        _this2.$message.error('添加失败，请重试');
        _this2.confirmLoading = false;
      });
    },
    getTagType: function getTagType(type) {
      var types = {
        1: 'danger',
        // 满减券
        2: 'warning',
        // 折扣券
        3: 'primary' // 其他类型
      };
      return types[type] || 'info';
    },
    getCouponTypeText: function getCouponTypeText(type) {
      var types = {
        1: '满减券',
        2: '折扣券',
        3: '其他'
      };
      return types[type] || '未知';
    },
    getStatusTagType: function getStatusTagType(status) {
      var statusMap = {
        0: 'info',
        // 未开始
        1: 'success',
        // 进行中
        2: 'warning',
        // 已暂停
        3: 'danger' // 已结束
      };
      return statusMap[status] || 'info';
    }
  }
};